import React from 'react';
import './ForgetPassword.scss';  
import backgroundImg from "../../../Assets/image (58).png";
import mainLogo from "../../../Assets/image (90).png";
import sideLogo from "../../../Assets/image (59).png";
import emailImg from "../../../Assets/image (53).png";

export default function ForgetPassword() {
  return (

      


 
        <div className="forget-container">
          <div className="forget-text">
            <h2>Email Address</h2>
            <img src={emailImg} alt="Email Illustration" width={170} />
            <p>First, tell us what is your email address</p>
          </div>

          <div className="forget-input-wrapper">
        
            <input type="text" placeholder="Email Address" />
          </div>

          <button className="forget-button">Continue</button>
        </div>
  
 
  );
}
